<div  *ngIf="isLoading" class="overlay overlay-block cursor-default modal-body">
    <ng-container>
        <div class="overlay-layer bg-transparent">
            <div class="spinner spinner-lg spinner-success"></div>
        </div>
    </ng-container>
</div>  

<div *ngIf="!isLoading">
    <div style="background-color: #969696; color: #969696;">
        <div class="row m-2">
            <div class="col-12">
                <kkis-app-webshop-aktions-artikel (numberWarenkorbItems)="getNumberWarenkorbItems($event)"></kkis-app-webshop-aktions-artikel>
                <!-- <img src="./assets/media/Logo.jpg" class="img-fluid"> -->
            </div>
        </div>
    </div>
</div>